import {MyopBindMessage, MyopBindReplayMessage, Ref} from "./BaseMessage";
import {MyopMessageKey} from "../common/MyopMessages";

const ReplayMessageKey = 'GetAttributeReplayMessage'

export class GetAttributeMessage extends MyopBindMessage<void, GetAttributeReplayMessage> {
    replyMessageKey: MyopMessageKey = ReplayMessageKey
    messageType = 'GetAttributeMessage';

    constructor(public ref: Ref, public name: string, handler: (message: GetAttributeReplayMessage) => void) {
        super(handler);
    }
}

export class GetAttributeReplayMessage extends MyopBindReplayMessage {
    messageType = ReplayMessageKey

    constructor(public content: string | null) {
        super();
    }
}

